import { createContext, useContext, useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import { getUserFromToken } from '../services/data'
import { useLocation, useNavigate } from 'react-router-dom'

const AuthContext = createContext()
let externalLogout = () => {}

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [userdata, setUserdata] = useState(null)

  const location = useLocation()
  const navigate = useNavigate()

  const login = userData => {
    setIsAuthenticated(true)
    setUserdata(userData)
    localStorage.setItem('owner_account', true)
  }

  const logout = () => {
    setIsAuthenticated(false)
    setUserdata(null)
    Cookies.remove('user')
    Cookies.remove('token')
    document.querySelector('mag-chatbot')?.classList.add('hidden')
    window.dispatchEvent(new CustomEvent('checkStoreId', { detail: false }))
    window.dispatchEvent(new CustomEvent('authLogout'))
  }

  externalLogout = logout

  useEffect(() => {
    const whitelistedPaths = [
      '/',
      '/register',
      '/forgot-password',
      '/reset-password',
      '/pages/privacy-policy',
      '/pages/terms-conditions'
    ]

    if (whitelistedPaths.includes(location.pathname)) return

    const initAuth = async () => {
      const user = await getUserFromToken()
      if (user) {
        setIsAuthenticated(true)
        setUserdata(user)
      } else {
        logout()
        navigate('/')
      }
    }

    if (!userdata) {
      initAuth()
    }
  }, [userdata, location.pathname, navigate])

  return (
    <AuthContext.Provider value={{ isAuthenticated, userdata, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
export const getLogout = () => externalLogout
